// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TKQamMxVTk0fwdhVbmYs{flex-direction:column;display:flex}.Q4X63DGYMPEy1z4LI0IT{list-style-type:initial;margin-left:20px}.Q4X63DGYMPEy1z4LI0IT li::marker{color:var(--light-blue-100)}.lmCktw9Ac9wGVmYBsz8K{margin-bottom:24px}.ZW0ZKzyQi44WqjLNNidW{justify-content:space-between;align-items:center;width:100%;display:flex}.yf4j9stCJwZvUQNGUIJT{align-items:center;gap:4px;display:flex}.pJV26KXVNMqPjwiRhIMM{margin-top:6px;padding:10px 0}.DOyZ9ZWrkU7Hh_Z0E4O9{gap:22px;min-height:64px;padding:12px 0}.DOyZ9ZWrkU7Hh_Z0E4O9 .TwZC2MrlhG4XpG08xSsa{flex:1}.fqQ1U2sTVrg5sKQ3nip3{cursor:default;align-items:center;padding:8px 12px;display:flex}.fqQ1U2sTVrg5sKQ3nip3>:first-child{height:-webkit-fit-content;height:fit-content;padding:4px 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContent": `TKQamMxVTk0fwdhVbmYs`,
	"alertList": `Q4X63DGYMPEy1z4LI0IT`,
	"configuration": `lmCktw9Ac9wGVmYBsz8K`,
	"section": `ZW0ZKzyQi44WqjLNNidW`,
	"sectionLabel": `yf4j9stCJwZvUQNGUIJT`,
	"leadOwner": `pJV26KXVNMqPjwiRhIMM`,
	"phoneField": `DOyZ9ZWrkU7Hh_Z0E4O9`,
	"selectContainer": `TwZC2MrlhG4XpG08xSsa`,
	"linkContainer": `fqQ1U2sTVrg5sKQ3nip3`
};
export default ___CSS_LOADER_EXPORT___;
